import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import router from './components/router.js'
import App from './App.vue'
import axios from 'axios'
import qs from 'qs'
import http from './utils/request'
import Cookies from 'js-cookie'
import commonComponents from './components/components.js'
import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';

import 'animate.css'

import 'element-plus/dist/index.css';

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
// 公共组件
app.use(commonComponents)

// 挂载全局
app.config.globalProperties.$qs = qs
app.config.globalProperties.$http = http
app.config.globalProperties.$cookies = Cookies
app.config.globalProperties.$axios = axios
app.config.globalProperties.qs = qs

app.mount('#app')
